import { useQuery } from "@tanstack/react-query";

import { intakeFormQueriesStore } from "../api";
import type { HealthieFormParams } from "../models";

export const useHealthieForm = (params: HealthieFormParams) => {
  return useQuery(intakeFormQueriesStore.healthie.form(params));
};
